import { z } from 'zod'

export const zSmallestUnitPrice = z.object({
  unitName: z.string(),
  unitPrice: z.number(),
  unitPriceWithVat: z.number(),
})

export type SmallestUnitPriceSchema = z.infer<typeof zSmallestUnitPrice>
